import React from 'react';

import CybsCard from '@cybs-ui/components/lib/card';
import CybsActionBar from '@cybs-ui/components/lib/action-bar';
import CybsFormFooter from '@cybs-ui/components/lib/form-footer';
import {connect} from 'react-redux';
import {loadUrlInNewTab, setWindowLocationHash} from '../../../../../libs/common-library';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import '../../../components/rhs-components/css/how-it-works.css';
import $ from 'jquery';
import { getLHSBasedOnHostName, getLHSJsonData, initiateDeepLink } from '../../../../../lhs/actions/navigation-actions';
import { putDataInDevCenterDataStore } from '../../../../../app/store';
import { getPrerequisitesFlag } from '../../../../../lhs/reducers/lhs-reducer';


const title = 'Overview';

var rightButtons;

class HowItWorks extends React.Component
{
  render(){

    setTimeout(function(){
        $('.prerequisitesSection a').each(function(){
          this.addEventListener("click",function(){
            var href = this.getAttribute('href');
            if(href.length > 0 && href[0] == '#'){
              var deeplinkArray = href.replace('#','').split('_');
              const customData = require('../../../../../dist/json/lhs/'+getLHSBasedOnHostName());
              var lhsContents = getLHSJsonData([], customData,{}, false);
              putDataInDevCenterDataStore({type: 'UPDATE_PREREQUISITES_FLAG', prerequisitesFlag: true});
              initiateDeepLink(lhsContents, deeplinkArray[2]);
              putDataInDevCenterDataStore({type: 'UPDATE_SELECTED_API', selectedApi: deeplinkArray[2]});
            }
          })
      });
    }, 10);

    marked.setOptions({
      gfm: true,
      breaks: true,
    })
    rightButtons=[];
    if(this.props.responseCodes != undefined){
      rightButtons.push(  { 
        label: 'See Response Codes',
        onClick: () => loadUrlInNewTab(this.props.responseCodes),
        colorScheme: 'secondary',
        dataTest: 'see response code',
        className : "border_color_theme_primary",
        id:'seeResponseCode'
      })
    }
    if(this.props.testingTriggers != undefined){
      rightButtons.push({
        label: 'Testing Triggers',
        onClick: () =>loadUrlInNewTab(this.props.testingTriggers),
        colorScheme: 'secondary',
        dataTest: 'testing trigger',
        className : "border_color_theme_primary",
        id:'testingTrigger'
      })
    }
    return(
      <div id = "summarySection" class = "summarySection" style={{'display':'flex'}}>
        <CybsCard
          dataTest="card-example-with-footer"
          header={
            <CybsActionBar
              dataTest="payment-info-with-collapsible"
              i18n={{ title: title }}
            />
          }
          bodyMaxHeight={100}
          footer={
            <CybsFormFooter
              dataTest="payment-info"
              rightButtons={rightButtons}
              style={{ padding:'0px' }}
            />
          }
        >
          {this.props.description && <p dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(marked(this.props.description))}}></p>}
        </CybsCard>
        {this.props.xApiDependencies && 
        <CybsCard
          dataTest="card-example-with-footer"
          header={
            <CybsActionBar
              dataTest="payment-info-with-collapsible"
              i18n={{ title: 'Prerequisites' }}
            />
          }
          style={{marginLeft:'10px'}}
          bodyMaxHeight={100}
        >
          <div class = "prerequisitesSection">
          { 
            this.props.xApiDependencies.map(
              dependency =>
              <p dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(marked(dependency.api + ' : ' + dependency.description))}}></p>
            )
          }
          </div>
        </CybsCard>
      }
      </div>
    )
  }
}


function mapStateToProps(state){
  return{
    description: state.lhsReducer.description,
    xApiDependencies: state.lhsReducer.xApiDependencies,
    responseCodes :state.rhsReducer.responseCodes,
    testingTriggers: state.rhsReducer.testingTriggers
  }
}

export default connect(mapStateToProps)(HowItWorks);
